import { Card, H2, Separator } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';
import { Fragment } from 'react/jsx-runtime';

import { CheckingOptionInManualReviewRow } from './CheckingOptionInManualReviewRow';
import { CheckingReceivedInvitationRow } from './CheckingReceivedInvitationRow';

import { useProductOnboardingOptions } from '../hooks/useProductOnboardingOptions';

export const ProductOnboardingIntentsCard: React.FC = () => {
  const { data } = useProductOnboardingOptions();

  if (!data) return <CardLoader />;

  const { checkingOptionInManualReview, checkingReceivedInvitations } = data.intents;
  if (!checkingOptionInManualReview && !checkingReceivedInvitations.length) return null;

  return (
    <Card data-testid="specPageProductIntentsCard">
      <Card.Header css={{ display: 'flex', justifyContent: 'space-between', padding: 'space.300' }}>
        <H2 variant="title200">Finish setting up</H2>
      </Card.Header>
      <Card.Content>
        {checkingOptionInManualReview && (
          <Fragment key={1}>
            <Separator css={{ fullWidthWithInset: 'space.300' }} />
            <CheckingOptionInManualReviewRow option={checkingOptionInManualReview} />
          </Fragment>
        )}
        {checkingReceivedInvitations.map(invitation => (
          <Fragment key={invitation.id}>
            <Separator css={{ fullWidthWithInset: 'space.300' }} />
            <CheckingReceivedInvitationRow invitation={invitation} />
          </Fragment>
        ))}
      </Card.Content>
    </Card>
  );
};
